<template>
    <div class="modal-auth-telegram">
        <div class="modal-auth-telegram__title">
            Ждём подтверждения в Telegram
        </div>
        <div class="modal-auth-telegram__text">
            Поделитесь контактом в Telegram {{ formattedNumber }} и нажмите «Готово»
        </div>

        <div>
            <ui-button
                v-on:click="submitHandler"
                style="height: 48px"
                is-uppercase
            >
                ГОТОВО
            </ui-button>
        </div>

        <div class="modal-auth-telegram__error" v-if="isError">
            Что-то пошло не так. Пожалуйста,<br> попробуйте ещё раз
        </div>

        <div class="modal-auth-telegram__footer">
            <div class="modal-auth-telegram__request">
                <a
                    class="modal-auth-telegram__request-trigger"
                    v-bind:href="url"
                    target="_blank"
                >
                    Открыть Telegram
                </a>
            </div>
            <div class="modal-auth-telegram__request">
                <span
                    class="modal-auth-telegram__request-trigger"
                    v-if="requestCodeIsAvailable"
                    v-on:click="openSmsModal"
                >
                    Получить код по смс
                </span>
                <span class="modal-auth-telegram__request-hint" v-else>
                    Получить код по смс можно через {{ cooldownFormatted }}
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import { mainClient } from '~/network';
import utils from '~/utils';
import config from '~/config';

export default {
    name: 'modal-auth-telegram',
    props: {
        phone: {
            type: String,
        },
        onSuccess: {
            type: Function,
            default: null,
        },
        onShowSmsModal: {
            type: Function,
            default: null,
        },
    },
    data: () => ({
        isError: false,
    }),
    computed: {
        ...mapState('sms', [
            'requestCodeIsAvailable',
            'requestCodeTimer',
        ]),
        formattedNumber() {
            return utils.formats.formatPhone(this.phone);
        },
        cooldownFormatted() {
            const cooldown = Math.round(this.requestCodeTimer / 1000);
            const minutes = Math.floor(cooldown / 60);
            const seconds = cooldown - minutes * 60;
            return `${minutes < 10 ? '0' : ''}${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
        },
        cleanPhone() {
            return this.phone.replace(/^\+|\D/g, '');
        },
        url() {
            return `${config.urls.telegramBot}?start=${this.cleanPhone}-ru-web`;
        },
    },
    methods: {
        async submitHandler() {
            const { status } = await mainClient.user.checkTelegramAuth({
                phone: this.cleanPhone,
            });
            if (status === 200) {
                this.isError = false;
                this.$store.dispatch('user/getUser');
                if (this.onSuccess) {
                    this.onSuccess();
                }
                this.close();
            } else {
                this.isError = true;
            }
        },
        close() {
            this.$store.commit('modals/pop');
        },
        openSmsModal() {
            this.close();
            if (this.onShowSmsModal) {
                this.onShowSmsModal();
            }
        },
    },
    mounted() {
        window.open(this.url, '_blank');
    },
};
</script>

<style scoped lang="less">
@import '~theme';

.modal-auth-telegram {
    .mixin-modal();

    position: relative;

    max-width: 460px;
    padding: 40px;

    box-shadow: 0 0 60px 0 @color-accent-cold;
    &__loader {
        .transition-fade();

        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;

        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;

        background: @color-gray-lightest;
        &-container {
            width: 50px;
        }
    }
    &__title {
        margin-bottom: 12px;

        text-transform: uppercase;
    }
    &__text {
        max-width: 425px;
        margin-bottom: 36px;
    }
    &__form {
        width: 100%;
        max-width: 240px;
        margin-bottom: 36px;
    }
    &__error {
        margin-top: 8px;

        color: @color-accent-warm;
    }
    &__footer {
        display: flex;
        flex-direction: column;
        gap: 6px;
    }
    &__request {
        &:first-child {
            margin-top: 24px;
        }
        &-trigger {
            .mixin-link-decoration();

            cursor: pointer;
        }
    }
    @media @media-md-down {
        &__title {
            margin-bottom: 9px;
        }
    }
}
</style>
